'use strict';

const $window   = $(window);
const $document = $(document);
const $html     = $('html');
const $body     = $('body');

let wW          = $window.outerWidth();
let wH          = $window.outerHeight();
let dH          = $document.outerHeight();

$document.on('preloaded.after', function () {
    $window
        .on('scroll', function () {
            Animator.onScroll();

            if (typeof Navigation !== 'undefined') { Navigation.onScroll(); }
        })
        .trigger('scroll');
});

$document.on('preloaded.before', function () {
    if (!Is.mobile.ANY()) {
        let c = new ScrollMagic.Controller();
        Timeline.setup(c);
    }

    $window
        .on('resize', function () {
            wW = $window.outerWidth();
            wH = $window.outerHeight();
            dH = $document.outerHeight();
        });

    Component.init();

    if (typeof Navigation !== 'undefined') { Navigation.init(); }

    $('img[data-src]').lazyload({ data_attribute: 'src', effect : 'fadeIn' });

    // Add your code here
    Navigation.on('./', function(url){
        Navigation.helpers.scrollTo(url);
    });

    Navigation.on('sobre-nosotros', function(url){
        Navigation.helpers.scrollTo(url);
    });

    Navigation.on('beneficios', function(url){
        Navigation.helpers.scrollTo(url);
    });

    Navigation.on('onde-encontrar', function(url){
        Navigation.helpers.scrollTo(url);
    });

    Navigation.on(':pet/productos/:type', function(url){
        Navigation.helpers.scrollTo(url);
    });

    $window.trigger('resize').trigger('popstate');

    /*
    if($('[data-component="page-home"]').length == 0){
        let message = $('[data-item-warning="txt-warning-bifinhos"]');
        $('[data-component="modal"]').trigger('modal:open', [
            {
                title: 'Comunicado',
                message: message,
                name: 'modal-bifinhos'
            }
        ]);
    }*/

});

$body.waitForImages(true)
    .progress((loaded, count, success) => {
        count++;

        let percent = (loaded * 100 / count);

        TweenLite.to('.preloader__bar__progress', .4, { width: percent+'%', ease: Power2.easeInOut });
    })
    .done(() => {
        TweenLite.to('.preloader__bar__progress', .3, { width: '100%', onComplete: () => {
            $document.trigger('preloaded.before');

            TweenLite.to('.preloader', .2, { opacity: 0, display: 'none', ease: Linear.easeNone, onComplete: () => $document.trigger('preloaded.after') });
        } });
    });
